(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ely-photo-gallery')) customElements.define('ely-photo-gallery', class extends HTMLElement {
  connectedCallback() {
    this.style.display='block';this.row=this.querySelector('.hdt-banner-row');if(!this.row)return;
    this.row.tabIndex=0;this.abort=new AbortController();const opts={signal:this.abort.signal};
    this.update=()=>{
      this.querySelectorAll('[data-dir]').forEach(b=>b.disabled=Number(b.dataset.dir)<0?this.row.scrollLeft<=1:this.row.scrollLeft>=this.row.scrollWidth-this.row.clientWidth-1);
      const dots=this.querySelector('.ely-gallery-dots'), count=Math.ceil(this.row.children.length/2);
      if(dots.children.length!==count){dots.replaceChildren(...Array.from({length:count},()=>document.createElement('span')));}
      const step=(this.row.children[1]?.offsetLeft-this.row.children[0]?.offsetLeft)||this.row.clientWidth/2;
      const active=Math.min(count-1,Math.round(this.row.scrollLeft/(step*2)));
      [...dots.children].forEach((dot,i)=>dot.classList.toggle('active',i===active));
      dots.style.visibility=count>1?'visible':'hidden';
    };
    this.querySelectorAll('[data-dir]').forEach(b=>b.addEventListener('click',()=>this.row.scrollBy({left:Number(b.dataset.dir)*this.row.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),opts));
    this.row.addEventListener('scroll',this.update,opts);this.resize=new ResizeObserver(this.update);this.resize.observe(this.row);this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
});

  } catch(e) { console.error(e); }
})();
})();
